import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  scheduler: (state: State) => state.scheduler,
  schedulerInitData: (state: State) => state.schedulerInitData,
  schedulers: (state: State) => state.schedulers,
} as GetterTree<State, any>;
